import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';

export const deepDeps = (deps) => deps.map(useDeepMemoize);

export const useDeepMemoize = (value) => {
	const ref = useRef();
	if (!isEqual(value, ref.current)) {
		ref.current = value;
	}
	return ref.current;
};

// useEffect but with deep dependency comparison
// more effective then JSON.stringify
const useDeepEffect = (callback = () => {}, deps = []) => {
	useEffect(callback, deepDeps(deps));
};

export default useDeepEffect;
